import React from "react";
import './my-assessments.scss';
import { getImageSource, getThemeImageSource } from "../../../utility/image-source";
import { Constants, ImageConstants } from "../../../constants/constants";
import ChapterList from "../../common/chapter-list/chapter-list";
import SharedProfile from "../../../../shared-storage/profile";
import CommonApi from "../../../apis/common";
import StartAssessment from "../../common/start-assessment/start-assessment";
import AssessmentEngine from "../../common/assessment-engine/assessment-engine";
import SharedThemeCategory from "../../../../shared-storage/category-theme";
import AssessmentEndScreen from "../../my-assessments/assessment-end-screenV1/assessment-end-screenV1";
import MyAssessmentResult from "../../my-assessment-result/my-assessment-result";
import AssessmentApi from "../../../apis/assessment";
import Path from "../../routes/routes-path";
import CompletedAssessmentsList from "./completed-assessments-list/completed-assessments-list";
import ClassMockTestPerformanceReport from "../../class-mock-test-performance-report/class-mock-test-performance-report";
import { Modal, ModalBody } from "reactstrap";
import CwSubscriptionModal from "../../common/cw-subscription-modal/cw-confirmation-modal";
import Loading from "../../common/loading/loading";
import ChapterEloAssessmentReport from "../../student-report/student-report";


class MyAssessments extends React.Component {

    state = {
        searchText: '',
        showStartAssessment: false,
        showAssessmentEngine: false,
        showAssessmentEndScreen: false,
        showViewAnswersScreen: false,
        mockTestList: [],
        selectedAssessmentType: '',
        isLoading : false
    }


    constructor(props) {
        super(props)

        this.userInfo = SharedProfile.getProfile()
    }

    questionSetHash = {}

    componentDidMount() {
        this.getAssessmentMeta()
        this.getUserAssessmentActivity()

        let chapterInfo = this.props.history?.location?.state?.data
        if (chapterInfo && (chapterInfo.calledFrom === 'EXAM_PREP_KIT' || chapterInfo.calledFrom === 'EXAM_PREP_KIT_V2')) {
            console.log(chapterInfo)

            if (chapterInfo.actionType === 'VIEW_ANSWERS') {
                this.setState({
                    showViewAnswersScreen: true,
                    assessmentEndScreenInfo: { assessmentActivityId: chapterInfo.assessmentActivityId },
                    chapterKey: chapterInfo.chapterKey,
                    chapterTitle: chapterInfo.chapterTitle,
                    categoryThemeId: chapterInfo.categoryThemeId
                });
            } else if (chapterInfo.actionType === 'VIEW_REPORT') {
                this.setState({
                    showPerformanceReport: true,
                    assessmentActivityId: chapterInfo.assessmentActivityId,
                    selectedMockTestTitle: chapterInfo.chapterTitle,
                    chapterKey: chapterInfo.chapterKey,
                    chapterTitle: chapterInfo.chapterTitle,
                    categoryThemeId: chapterInfo.categoryThemeId,
                    calledFrom: chapterInfo.calledFrom
                });
            } else if (chapterInfo.isResume) {
                this.setState({
                    showAssessmentEngine: true,
                    isResume: true,
                    assessmentActivityId: chapterInfo.assessmentActivityId,
                    chapterKey: chapterInfo.chapterKey,
                    chapterTitle: chapterInfo.chapterTitle,
                    categoryThemeId: chapterInfo.categoryThemeId,
                    calledFrom: chapterInfo.calledFrom
                });
            } else {
                let chapter = {
                    chapterKey: chapterInfo.chapterKey,
                    chapterTitle: chapterInfo.chapterTitle,
                    categoryId: chapterInfo.categoryThemeId,
                    calledFrom: chapterInfo.calledFrom,
                    assessmentActivityId: chapterInfo.assessmentActivityId,
                    questionSetId: chapterInfo.questionSetId
                }
                this.onStart(chapter)
            }
        }

        if (this.props.meta && this.props.meta.from === 'CHAPTER_ACTIVITY') {
            let chapter = {
                chapterKey: this.props.meta.chapterKey,
                chapterTitle: this.props.meta.chapterTitle,
                categoryId: this.props.meta.categoryThemeId,
                from: this.props.meta.from
            }
            this.onStart(chapter)
        }

        // EPK V2: School assignment or Self-Assessment — jump directly to StartAssessment or Answers/Report
        if (this.props.meta && this.props.meta.from === 'EXAM_PREP_KIT_V2') {
            const isFromMyHomework = !!this.props.meta.isFromMyHomework;
            const assessmentActivityId = this.props.meta.assessmentActivityId || this.props.meta.homeworkActivityId;

            let stateUpdate = {
                chapterKey: this.props.meta.chapterKey,
                chapterTitle: this.props.meta.chapterTitle,
                categoryThemeId: this.props.meta.categoryThemeId,
                isFromMyHomework: isFromMyHomework,
                homeworkActivityId: this.props.meta.homeworkActivityId,
                homeworkId: this.props.meta.homeworkId,
                from: isFromMyHomework ? 'HOMEWORK' : 'MOCK_TEST',
                calledFrom: this.props.meta.calledFrom || 'EXAM_PREP_KIT',
                isBaseline: !!this.props.meta.isBaseline,
                isFinishLine: !!this.props.meta.isFinishLine
            };

            if (this.props.meta.actionType === 'VIEW_ANSWERS') {
                stateUpdate.showViewAnswersScreen = true;
                stateUpdate.assessmentEndScreenInfo = { 
                    assessmentActivityId: assessmentActivityId,
                    chapterKey: this.props.meta.chapterKey,
                    chapterTitle: this.props.meta.chapterTitle,
                    categoryThemeId: this.props.meta.categoryThemeId,
                    fromAssess: true,
                    isFromMyHomework: isFromMyHomework,
                    calledFrom: this.props.meta.calledFrom || 'EXAM_PREP_KIT',
                    from: isFromMyHomework ? 'HOMEWORK' : 'MOCK_TEST',
                    isBaseline: !!this.props.meta.isBaseline,
                    isFinishLine: !!this.props.meta.isFinishLine
                };
            } else if (this.props.meta.actionType === 'VIEW_REPORT') {
                stateUpdate.showPerformanceReport = true;
                stateUpdate.assessmentActivityId = assessmentActivityId;
                stateUpdate.selectedMockTestTitle = this.props.meta.chapterTitle;
                stateUpdate.selectedItem = {
                    schoolAssessmentId: this.props.meta.homeworkId,
                    type: isFromMyHomework ? 'HOMEWORK' : 'MOCK_TEST',
                    chapterTitle: this.props.meta.chapterTitle,
                    chapterKey: this.props.meta.chapterKey,
                    isBaseline: !!this.props.meta.isBaseline,
                    isFinishLine: !!this.props.meta.isFinishLine
                };
            } else if (this.props.meta.isResume) {
                stateUpdate.showAssessmentEngine = true;
                stateUpdate.isResume = true;
                if (this.props.meta.questionSetId) {
                    stateUpdate.questionSetId = this.props.meta.questionSetId;
                }
                if (this.props.meta.assessmentActivityId) {
                    stateUpdate.assessmentActivityId = this.props.meta.assessmentActivityId;
                }
            } else {
                stateUpdate.showStartAssessment = true;
                if (this.props.meta.questionSetId) {
                    stateUpdate.questionSetId = this.props.meta.questionSetId;
                }
                if (this.props.meta.assessmentActivityId) {
                    stateUpdate.assessmentActivityId = this.props.meta.assessmentActivityId;
                }
            }

            this.setState(stateUpdate);
        }

    }






    getAssessmentMeta = () => {

        CommonApi.getMiscellaneousList({ type: 'ASSESSMENT_META' }).then((data) => {
            if (data) {
                this.setState({ assessmentMeta: data.response[0] })
            }
        }).catch(err => {
            if (err) {

                return
            }
        })
    }

    getUserAssessmentActivity() {


        let payload = {}

        this.setState({isLoading : true})

        AssessmentApi.getUserAssessmentActivity(payload).then(res => {
            console.log(res)

            let selectedChapterMockTest = []

            selectedChapterMockTest = res.contents.filter(assessment => {
                if (assessment.type === 'SELECTED_CHAPTER_MOCK_TEST') {
                    return assessment.type === 'SELECTED_CHAPTER_MOCK_TEST'
                }

                if (assessment.type === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST') {
                    return assessment.type === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST'
                }
            }
            )

            // console.log(selectedChapterMockTest)

            let filteredContents = res.contents.filter(assessment => (assessment.type !== 'SELECTED_CHAPTER_MOCK_TEST' || assessment.type !== 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST'))

            if (filteredContents.length > 0) {
                this.setState({ content: filteredContents })
            }

            if (selectedChapterMockTest.length) {
                selectedChapterMockTest.forEach(item => this.questionSetHash[item.questionSetId] = item)
                this.setState({ selectedChapterMockTest })
            }

            this.getMockTestList()

        }).catch(err => {
            console.log(err)
        })
    }


    getMockTestList() {
        let payload = {
            type: 'CLASS_MOCK_TEST'
        }
        AssessmentApi.getMockTestList(payload).then(res => {
            console.log(res)

            let mockTestList = []

            res.questionSetList.forEach(item => {

                if (this.questionSetHash[item._id]) {
                    console.log('inside......')
                    let questionSet = this.questionSetHash[item._id]
                    questionSet.chapterName = item.chapterName ? item.chapterName : ''
                    mockTestList.push(questionSet)
                } else {
                    item.questionSetId = item._id
                    item.status = 'START'
                    item.duration = res.duration
                    mockTestList.push(item)
                }
            })


            

            let targetId = "678f5f882559f1afd1cfb899"; // ID of the object to move  - Diagnostic Assessment 3
            

            let index = mockTestList.findIndex(obj => (obj._id === targetId || obj.questionSetId === targetId));

            if (index !== -1) {
                // Remove the object from its current position
                let [targetObj] = mockTestList.splice(index, 1);
                // Add the object to the first position
                mockTestList.unshift(targetObj);
            }



            targetId = "676263662559f1afd1cfa9e2"; // ID of the object to move  - Diagnostic Assessment 2


            index = mockTestList.findIndex(obj => (obj._id === targetId || obj.questionSetId === targetId));

            if (index !== -1) {
                // Remove the object from its current position
                let [targetObj] = mockTestList.splice(index, 1);
                // Add the object to the first position
                mockTestList.unshift(targetObj);
            }

            targetId = "677dfe1f2559f1afd1cfb01c"; // ID of the object to move - Modified Diagnostic Assessment 1

            index = mockTestList.findIndex(obj => (obj._id === targetId || obj.questionSetId === targetId));

            if (index !== -1) {
                // Remove the object from its current position
                let [targetObj] = mockTestList.splice(index, 1);
                // Add the object to the first position
                mockTestList.unshift(targetObj);
            }


            console.log(mockTestList)

            this.setState({ mockTestList: mockTestList, isLoading: false })
        }).catch(err => {
            console.log(err)
        })
    }


    setSearchText(event, key) {
        this.setState({ [key]: event.target.value }, () => {
            if (!this.state.searchText) {
                this.getSearchedChapterList()
            }
        })
    }


    getSearchedChapterList() {
        this.setState({ reload: true }, () => {
            this.setState({ reload: false })
        })
    }

    goToHomeScreen() {
        return this.props.history.replace({ pathname: Path.HOME })
    }

    renderBreadcrumbForChapterList = () => {
        return (
            <div className='breadcrumb'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                <span className='title-1 pl-2' >{`Mock Test`}</span>
            </div>
        )
    }

    onStart = (data) => {
        // console.log(data)
        this.setState({
            showStartAssessment: true,
            chapterKey: data.chapterKey, chapterTitle: data.chapterTitle,
            categoryThemeId: data.categoryId,
            from: data.from ? data.from : '',
            questionSetId: data.questionSetId ? data.questionSetId : null,
            calledFrom: data.calledFrom ? data.calledFrom : ''
        })
        // this.props.navigation.navigate('StartAssessment', { meta: { chapterKey: data.chapterKey, chapterTitle: data.chapterTitle, categoryThemeId: data.categoryId } })
    }

    hideStartAssessmentScreen() {
        if (this.state.calledFrom === 'EXAM_PREP_KIT' || this.state.calledFrom === 'EXAM_PREP_KIT_V2') {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }
        this.setState({ showStartAssessment: false })
    }

    showAssessmentEngine(data) {
        //console.log(data)
        this.setState({ showAssessmentEngine: true, showStartAssessment: false, ...data })
    }

    showAssessmentEndScreen(assessmentCompletedInfo) {
        console.log(assessmentCompletedInfo)
        this.setState({ showAssessmentEngine: false, showAssessmentEndScreen: true, ...assessmentCompletedInfo })
    }

    hideAssessmentEndScreen() {
        const isEPK = this.state.calledFrom === 'EXAM_PREP_KIT' ||
            this.state.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.calledFrom === 'EXAM_PREP_KIT' ||
            this.props.meta?.from === 'EXAM_PREP_KIT_V2' ||
            this.state.isExamPrepKit;

        if (isEPK) {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }
        this.setState({ showAssessmentEndScreen: false }, () => {
            this.getUserAssessmentActivity()
        })
    }

    showViewAnswersScreen(assessmentEndScreenInfo) {
        this.setState({ showViewAnswersScreen: true, showAssessmentEndScreen: false, assessmentEndScreenInfo: assessmentEndScreenInfo.meta })
    }

    hideViewAnswersScreen(value) {
        // console.log('here....')

        const isEPK = this.state.calledFrom === 'EXAM_PREP_KIT' ||
            this.state.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.calledFrom === 'EXAM_PREP_KIT_V2' ||
            this.props.meta?.calledFrom === 'EXAM_PREP_KIT' ||
            this.props.meta?.from === 'EXAM_PREP_KIT_V2' ||
            this.state.isExamPrepKit;

        if (isEPK) {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }

        if (this.props.delegate && this.props.delegate.hideMockTest && value) {
            this.props.delegate && this.props.delegate.hideMockTest && this.props.delegate.hideMockTest()
        }

        this.setState({ showViewAnswersScreen: false, showAssessmentEndScreen: false }, () => {
            this.getUserAssessmentActivity()
        })
    }

    showCompletedAssessments() {
        this.hideViewAnswersScreen()
        this.hidePerformanceReport()
        this.hideStartAssessmentScreen()
        this.setState({ showCompletedAssessments: true }, () => {
            this.getUserAssessmentActivity()
        })
    }

    hideCompletedAssessments() {
        this.setState({ showCompletedAssessments: false })
    }

    onClickCard = (item) => {
        this.hideCompletedAssessments()
        this.hideStartAssessmentScreen()

        if (item.status == 'IN_PROGRESS') {

            let chapters = []


            if (item.type == Constants.REFRESHER_COURSE) {

                this.showAssessmentEngine({
                    chapterTitle: "Diagnostic Assessment",
                    isResume: true,
                    assessmentActivityId: item._id,
                    categoryThemeId: "1",
                    assessmentId: item.assessmentId,
                    from: Constants.REFRESHER_COURSE
                })
                // this.props.navigation.navigate('AssessmentEngine', {
                //     meta: {
                //         chapterTitle: "Diagnostic Assessment",
                //         isResume: true,
                //         assessmentActivityId: item._id,
                //         categoryThemeId: "1",
                //         assessmentId: item.assessmentId,
                //         from: Constants.REFRESHER_COURSE
                //     }
                // })
                return
            }
            if (item.chapterInfo) {
                console.log(item.chapterInfo)
                for (let i = 0; i < item.chapterInfo.length; i++) {
                    chapters.push(item.chapterInfo[i].title)
                }
            }
            // moengage.logCustomEvent('Assessment', { 'User Id': this.userInfo.userId, Status: 'Resume', Chapters: item.chapterInfo ? chapters.toString() : item.chapterTitle, 'Starting Point': 'Chapter Assessment' })
            // FireBaseEvent.logCustomEvent('Assessment', { 'User Id': this.userInfo.userId, Status: 'Resume', Chapters: item.chapterInfo ? chapters.toString() : item.chapterTitle, 'Starting Point': 'Chapter Assessment' })
            // Facebook.logCustomEvent('Assessment', { 'User Id': this.userInfo.userId, Status: 'Resume', Chapters: item.chapterInfo ? chapters.toString() : item.chapterTitle, 'Starting Point': 'Chapter Assessment' })
            // BranchIO.logCustomEvent('Assessment', { 'User Id': this.userInfo.userId, Status: 'Resume', Chapters: item.chapterInfo ? chapters.toString() : item.chapterTitle, 'Starting Point': 'Chapter Assessment' })

            this.showAssessmentEngine({
                chapterTitle: item.chapterTitle,
                isResume: true, assessmentActivityId: item._id,
                categoryThemeId: item.categoryId,
                selectedChapters: item.chapterInfo, assessmentType: item.type
            })

            // this.props.navigation.navigate('AssessmentEngine', { meta: { chapterTitle: item.chapterTitle, isResume: true, assessmentActivityId: item._id, categoryThemeId: item.categoryId, selectedChapters: item.chapterInfo } })
        } else {
            this.showViewAnswersScreen({ meta: { categoryThemeId: item.categoryId, chapterTitle: item.chapterTitle, chapterKey: item.chapterKey, assessmentActivityId: item._id } })
            // this.props.navigation.replace('MyAssessmentResult', { meta: { categoryThemeId: item.categoryId, chapterTitle: item.chapterTitle, chapterKey: item.chapterKey, assessmentActivityId: item._id } })
        }

    }


    navigate(item) {

        console.log(item)

        let type = 'SELECTED_CHAPTER_MOCK_TEST'

        if (item.questionSetType === "SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST") {
            type = 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST'
        }

        this.onStart({
            chapterKey: null, chapterTitle: item.chapterTitle, categoryId: 1, from: type,
            questionSetId: item.questionSetId
        })
    }

    showPerformanceReport = (item, index) => {
        console.log(item)
        this.setState({
            showPerformanceReport: true, assessmentActivityId: item._id, assessmentType: item.type,
            selectedMockTestTitle: `Mock Test ${index + 1}`,
            selectedItem: item
        })
    }

    showSingleChapterPerformanceReport(item) {
        console.log(item)
        this.hideCompletedAssessments()
        this.setState({
            showPerformanceReport: true, assessmentActivityId: item._id, assessmentType: item.type,
            selectedMockTestTitle: item.chapterTitle,
            selectedItem: item
        })
    }

    goToHomeScreen = () => {
        if (this.props.delegate && this.props.delegate.goToHomeScreen) {
            this.props.delegate.goToHomeScreen();
        } else if (this.props.history) {
            this.props.history.push('/student/home');
        }
    }

    goToPrepare = () => {
        if (this.props.delegate && this.props.delegate.goToPrepare) {
            this.props.delegate.goToPrepare();
        } else if (this.props.delegate && this.props.delegate.hideExamPrepKit) {
            this.props.delegate.hideExamPrepKit();
        } else if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
            this.props.delegate.hideSchoolAssessment();
        }
    }

    goToTableOfContents = () => {
        if (this.props.delegate && this.props.delegate.hideExamPrepKitV2) {
            if (this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            }
            this.props.delegate.hideExamPrepKitV2();
        } else if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
            this.props.delegate.hideSchoolAssessment();
        }
    }

    hidePerformanceReport = () => {
        if (this.state.calledFrom === 'EXAM_PREP_KIT' || this.state.calledFrom === 'EXAM_PREP_KIT_V2') {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }
        this.setState({ showPerformanceReport: false })
    }

    hideChapterAssessmentReport() {
        if (this.state.calledFrom === 'EXAM_PREP_KIT' || this.state.calledFrom === 'EXAM_PREP_KIT_V2') {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }
        this.hidePerformanceReport()
        this.showCompletedAssessments()
    }

    onSelectType(type) {
        this.setState({ selectedAssessmentType: type })
    }

    showSubscriptionPopup() {
        this.setState({
            showSubscriptionPopup: true,
            // chapterKey: data.chapterKey,
            // chapterTitle: data.chapterTitle,
            // categoryThemeId: data.categoryId,
            // isLocked: data.isLocked,
            // imageUrl: data.imageUrl
            // from: data.from ? data.from : '',
            // questionSetId: data.questionSetId ? data.questionSetId : null,
        })
    }

    closeSubscriptionPopup() {
        this.setState({
            showSubscriptionPopup: false
        })
    }


    getButton(item, index) {
        // console.log(item)

        item.chapterTitle = 'Maths Mock Test' + ` ${index + 1}`

        if (item.questionSetType === 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST') {
            item.chapterTitle = 'Science Mock Test' + ` ${index + 1}`
        }

        if (this.userInfo && !this.userInfo.isSubscribed && index > 2 && index <= 7) {
            return (
                <div className="text-center cursor-pointer" onClick={() => this.showSubscriptionPopup(item)}>
                    <img className='lock-icon-size' src={getImageSource(ImageConstants.LOCK)} />
                </div>
            )
        }

        if (item.status === 'START') {
            return (
                <div className="start-button text-center cursor-pointer" onClick={() => this.navigate(item, index)}>
                    Start
                </div>
            )
        } else if (item.status === 'IN_PROGRESS') {
            return (
                <div className="start-button text-center cursor-pointer" onClick={() => this.onClickCard(item, index)}>
                    Resume
                </div>
            )
        } else if (item.status === 'COMPLETED') {
            return (
                <div className="d-flex align-items-center" >
                    <div className="learning-gap-button text-center mr-4 cursor-pointer" onClick={() => this.showViewAnswersScreen({
                        meta: {
                            categoryThemeId: this.categoryThemeId,
                            chapterTitle: item.chapterTitle,
                            chapterKey: this.chapterKey,
                            assessmentActivityId: item._id,
                            fromAssess: true,
                        }
                    })}>
                        View Answers
                    </div>
                    <div className="insights-button text-center cursor-pointer" onClick={() => this.showPerformanceReport(item, index)}>
                        Insights
                    </div>

                </div>
            )
        }
    }


    renderMockTestList() {
        return (
            <div className="mt-3">
                {
                    this.state.mockTestList.map((item, index) => (
                        <div className={`d-flex flex-column justify-content-center pb-4 mb-4 ${index != this.state.mockTestList.length - 1 ? 'question-border-bottom' : ''}`}>
                            <div className={`question-set row mr-0 ml-0 align-items-center mb-1`}>
                                <div className="col pl-0">
                                    {
                                        index <= 7 ?
                                            <div className="d-flex align-items-center">
                                                <span className="set-text">Maths Mock Test {index + 1} </span><span className="ml-1 mins-text" > {` ( ${item.duration} mins )`} </span>
                                            </div>
                                            :
                                            // <div className="d-flex align-items-center">
                                            //     <span className="set-text">Science Mock Test 1</span>
                                            // </div>
                                            <></>
                                    }
                                </div>
                                <div className="col-3 pr-0 d-flex justify-content-end">
                                    {/* {item.questionSetType != 'SELECTED_CHAPTER_SCIENCE_CLASS_MOCK_TEST' ? this.getButton(item, index) : <></>} */}
                                    {this.getButton(item, index)}

                                </div>
                            </div>
                            {
                                index <= 7 ?
                                    <div className="chapter-name">
                                        {item.chapterName ? item.chapterName : ''}
                                    </div>
                                    :
                                    <></>
                            }

                        </div>
                    ))
                }
                <img className="divider-image-width mb-5" src={getThemeImageSource(ImageConstants.PRACTICE_QUESTION_DIVIDER, 1)} />
            </div>
        )
    }


    renderChapterList() {
        return (
            <div className="chapter-list">
                <div className="text-right">
                    <img className="header-image-size" src={getImageSource(ImageConstants.HEADER_BG_IMAGE)}></img>
                </div>
                <div className="header-title-margin-top">
                    {this.renderBreadcrumbForChapterList()}
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="title">Mock Test</div>
                        {/* <div className="mr-5">
                            <div className="insights-button cursor-pointer" onClick={() => this.showCompletedAssessments()}>My Mock Test</div>
                        </div> */}
                    </div>
                    <div>
                        <img className="divider-image-width" src={getImageSource(ImageConstants.TITLE_DIVIDER)}></img>
                    </div>
                </div>
                {
                    this.state.mockTestList && this.state.mockTestList.length ? this.renderMockTestList() : <></>
                }
                {/* {
                    !this.state.reload ?
                        <ChapterList
                            type="MY_ASSESSMENTS"
                            assessmentMeta={this.state.assessmentMeta}
                            searchedChapterName={this.state.searchText}
                            onSelectChapter={(chapter) => this.selectedChapter(chapter)}
                            delegate={this} />
                        : ''
                } */}
            </div>
        )
    }

    renderAssessmentTypeSelectionPopup() {
        return (
            <Modal className="cw-common-custom-modal-center-for-assessment-type-selection" isOpen={true} size={'lg'}  >
                <div className="pt-4 my-auto text-right">
                    <img className="challenge-header" src={getImageSource(ImageConstants.CONFIRMATION_MODAL_HEADER)}></img>
                    {this.props.showTrialFeatures ? <img className='badge-image' src={getImageSource(ImageConstants.BADGE_IMAGE)} /> : ''}
                    {/* <img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.COUNTRY_CLOSE_ICON)} onClick={() => this.onClickClose()} /> */}
                </div>
                <ModalBody>
                    <div className="pratice-container">
                        <div className="text-center header-text">Select Type Of Assessment</div>
                        <div className=' mt-4 mb-4 d-flex align-items-center flex-column'>
                            <div className="d-flex align-items-center justify-content-around mt-2">
                                {/* <div className="continue-button cursor-pointer text-center" onClick={() => this.onClickClose()}>
                                        {`OK`}
                                    </div> */}
                                <div className="take-challenge cursor-pointer  text-center" onClick={() => this.onSelectType('SIGNLE_CHAPTER')}>
                                    {`Single Chapter`}
                                </div>
                            </div>
                            {/* <div><img className='chapter-lock-image-size' src={getImageSource(ImageConstants.CHAPTER_LOCK)} /></div>
                            <div className='ml-2'><span className='header-text'>{this.props.chapterTitle}</span><span className='sub-text'> will be available soon.</span></div> */}
                        </div>
                        <div className=' mb-2 d-flex align-items-center flex-column'>
                            <div className="d-flex align-items-center justify-content-around mt-2">
                                <div className="take-challenge cursor-pointer  text-center" onClick={() => this.onSelectType('SELECTED_CHAPTER_MOCK_TEST')}>
                                    {`Multiple Chapters`}
                                </div>
                            </div>
                        </div>
                        <div className="position">
                            <img className="challenge-footer" src={getImageSource(ImageConstants.CONFIRMATION_MODAL_FOOTER)}></img>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    hideMockTest() {
        if (this.state.calledFrom === 'EXAM_PREP_KIT' || this.state.calledFrom === 'EXAM_PREP_KIT_V2') {
            if (this.props.delegate && this.props.delegate.hideSchoolAssessment) {
                this.props.delegate.hideSchoolAssessment();
            } else if (this.props.history) {
                this.props.history.goBack();
            }
            return;
        }
        this.props.delegate && this.props.delegate.hideMockTest && this.props.delegate.hideMockTest()
        this.setState({ showAssessmentEndScreen: false }, () => {
            this.getUserAssessmentActivity()
        })
    }

    goToHome() {
        this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
        this.goToHomeScreen()
    }



    render() {

        this.theme = SharedThemeCategory.getThemeCategory(this.state.categoryThemeId)
        //console.log(this.theme)


        if (this.state.showStartAssessment) {
            return (
                <StartAssessment delegate={this}
                    meta={{
                        chapterKey: this.state.chapterKey,
                        chapterTitle: this.state.chapterTitle,
                        categoryThemeId: this.state.categoryThemeId,
                        from: this.state.from ? this.state.from : '',
                        questionSetId: this.state.questionSetId ? this.state.questionSetId : null,
                        assessmentActivityId: this.state.assessmentActivityId ? this.state.assessmentActivityId : null,
                        showQuestionSetSelection: this.props.meta?.from ? this.props.meta?.from === 'CHAPTER_ACTIVITY' ? true : false : false,
                        isFromMyHomework: this.state.isFromMyHomework ? this.state.isFromMyHomework : false,
                        homeworkActivityId: this.state.homeworkActivityId ? this.state.homeworkActivityId : null,
                        homeworkId: this.state.homeworkId ? this.state.homeworkId : null,
                        calledFrom: this.props.meta && this.props.meta.calledFrom ? this.props.meta.calledFrom : null,
                        isBaseline: !!this.state.isBaseline,
                        isFinishLine: !!this.state.isFinishLine
                    }}
                />
            )
        }

        if (this.state.showAssessmentEngine) {
            const isSelfAssessmentWithExistingActivity = !this.state.isFromMyHomework &&
                !!this.state.assessmentActivityId &&
                (this.state.calledFrom === 'EXAM_PREP_KIT_V2' ||
                    this.props.meta?.calledFrom === 'EXAM_PREP_KIT_V2' ||
                    this.props.meta?.isBaseline ||
                    this.props.meta?.isFinishLine ||
                    this.state.isBaseline ||
                    this.state.isFinishLine);

            return (
                <AssessmentEngine meta={{
                    chapterKey: this.state.chapterKey,
                    chapterTitle: this.state.chapterTitle,
                    categoryThemeId: this.state.categoryThemeId,
                    questionSetId: this.state.questionSetId,
                    assessmentActivityId: this.state.assessmentActivityId ? this.state.assessmentActivityId : null,
                    assessmentId: this.state.assessmentId ? this.state.assessmentId : null,
                    isResume: this.state.isResume || isSelfAssessmentWithExistingActivity ? true : null,
                    selectedChapters: this.state.selectedChapters ? this.state.selectedChapters : null,
                    from: this.state.from ? this.state.from : '',
                    type: this.state.assessmentType ? this.state.assessmentType : '',
                    eventId: this.state.eventId ? this.state.eventId : null,
                    isExamPrepKit: this.state.isExamPrepKit ? this.state.isExamPrepKit : "",
                    homeworkChapters: this.state.homeworkChapters ? this.state.homeworkChapters : '',
                    homework: this.state.homework ? this.state.homework : {homeworkId : this.props.meta.homeworkId},
                    isFromMyHomework: this.state.isFromMyHomework ? this.state.isFromMyHomework : false,
                    homeworkActivityId: this.state.homeworkActivityId ? this.state.homeworkActivityId : null,
                    isDueDatePassed: this.state.isDueDatePassed ? this.state.isDueDatePassed : false,
                    viewAnswerTime: this.state.viewAnswerTime ? this.state.viewAnswerTime : null,
                    calledFrom: this.state.calledFrom ? this.state.calledFrom : null,
                    isBaseline: !!this.state.isBaseline,
                    isFinishLine: !!this.state.isFinishLine
                }}
                    delegate={this} />
            )
        }

        if (this.state.showAssessmentEndScreen) {
            return (
                <AssessmentEndScreen
                    metaInfo={this.state}
                    from={this.props.meta?.from ? this.props.meta.from : ''}
                    delegate={this}
                    showViewAnswersScreen={(fromAssess) => this.showViewAnswersScreen(fromAssess)}
                />
            )
        }

        if (this.state.showViewAnswersScreen) {
            return (
                <MyAssessmentResult
                    meta={this.state.assessmentEndScreenInfo}
                    chapterTitle={this.props.meta?.chapterTitle ? this.props.meta.chapterTitle : ""}
                    delegate={this}
                    hideViewAnswersScreen={() => this.hideViewAnswersScreen(true)} />
            )
        }

        if (this.state.showCompletedAssessments) {
            return (
                <CompletedAssessmentsList content={this.state.content} delegate={this} />
            )
        }

        if (this.state.showPerformanceReport && this.userInfo?.class === 'Class 10' && this.userInfo?.subjectId === Constants.MATHS_SUBJECTID) {
            return (
                <ClassMockTestPerformanceReport
                    meta={
                        {
                            assessmentActivityId: this.state.assessmentActivityId,
                            from: this.state.assessmentType || this.props.meta?.from,
                            selectedMockTestTitle: this.state.selectedMockTestTitle || this.props.meta?.chapterTitle,
                            calledFrom: this.state.calledFrom || this.props.meta?.calledFrom,
                            chapterTitle: this.props.meta?.chapterTitle || this.state.chapterTitle,
                            isFromMyHomework: this.state.isFromMyHomework !== undefined ? this.state.isFromMyHomework : this.props.meta?.isFromMyHomework
                        }
                    }
                    delegate={this} />
            )
        } else if (this.state.showPerformanceReport) {
            return (
                <ChapterEloAssessmentReport
                    delegate={this}
                    homeworkId={this.state.selectedItem?.schoolAssessmentId || this.state.homeworkId || this.props.meta?.homeworkId}
                    type={this.state.selectedItem?.type || this.state.assessmentType || this.props.meta?.from}
                    selectedItem={this.state.selectedItem || this.props.meta}
                    meta={{ assessmentActivityId: this.state.assessmentActivityId }}
                />
            )
        }




        return (
            <div className="class-specific-my-assessments">
                {

                    this.state.isLoading ? <Loading /> : this.renderChapterList()
                }
                {
                    this.state.showSubscriptionPopup && <CwSubscriptionModal showSubscriptionPopup={this.state.showSubscriptionPopup} delegate={this} modal={this.state.showSubscriptionPopup} chapterTitle={this.state.chapterTitle} imageUrl={this.state.imageUrl} />
                }

            </div>
        )
    }

}

export default MyAssessments;